import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import { initializeIcons } from "@fluentui/react";

import "./index.css";

import LayoutWrapper from "./layoutWrapper";
import i18next from "./i18n/config";

initializeIcons();

const router = createHashRouter([
    {
        // Public recipient page — sits OUTSIDE LayoutWrapper so it bypasses
        // the authentication check. The share token is the auth.
        path: "share/:token",
        lazy: async () => {
            const module = await import("./pages/share/SharedDocument");
            return { Component: module.default };
        }
    },
    {
        path: "/",
        element: <LayoutWrapper />,
        children: [
            {
                index: true,
                element: null // Chat is now rendered directly in Layout, always mounted
            },
            {
                path: "admin",
                lazy: async () => {
                    const module = await import("./pages/admin/Admin");
                    return { Component: module.default };
                  }
            },
            {
                path: "search",
                lazy: async () => {
                    const module = await import("./pages/search/Search");
                    return { Component: module.default };
                }
            },
            {
                path: "*",
                lazy: () => import("./pages/NoPage")
            }
        ]
    }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <I18nextProvider i18n={i18next}>
            <HelmetProvider>
                <RouterProvider router={router} />
            </HelmetProvider>
        </I18nextProvider>
    </React.StrictMode>
);
